import React from "react";
import SEO from "@/components/common/SEO";
import PageHero from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";

// Reusable legal/content page. Content is editable placeholder text.
export default function LegalPage({ seo, eyebrow, title, updated, breadcrumbs, sections = [] }) {
  return (
    <>
      <SEO {...seo} />
      <PageHero eyebrow={eyebrow} title={title} breadcrumbs={breadcrumbs} />
      <section className="container-page py-16 lg:py-24">
        <div className="max-w-3xl">
          {updated && <p className="text-[13px] text-muted-foreground mb-8">Last updated: {updated}</p>}
          <div className="space-y-9">
            {sections.map((s, i) => (
              <Reveal key={i} delay={i * 0.03}>
                <h2 className="font-heading font-bold text-[20px] lg:text-[22px] text-navy mb-3">{s.heading}</h2>
                {Array.isArray(s.body) ? (
                  <div className="space-y-3">
                    {s.body.map((p, j) => (
                      <p key={j} className="text-[15.5px] leading-[26px] text-muted-foreground">{p}</p>
                    ))}
                  </div>
                ) : (
                  <p className="text-[15.5px] leading-[26px] text-muted-foreground">{s.body}</p>
                )}
              </Reveal>
            ))}
          </div>
          <div className="mt-12 rounded-lg border border-dashed border-[#C3CDD3] bg-white p-5">
            <p className="text-[13px] text-muted-foreground">
              This is editable placeholder legal content and should be reviewed and adapted with qualified legal advice before publication.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
